var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"cirLine"}),_c('div',{staticClass:"firTitle"},[_c('span',{staticClass:"cirCon"},[_vm._v(_vm._s(_vm.num))]),_vm._v(_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"box-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }